import { Option } from "api/common/types/common.types";
import { withForm } from "components/Forms/AppForm";

import { ecrFormDefaultValues } from "./ecrFormDefaultValues";

const EcrProtectionProfileSection = withForm({
  defaultValues: ecrFormDefaultValues,
  props: {
    ppOptions: [] as Option[],
  },
  render: function Render({ form, ppOptions }) {
    return (
      <form.FormSection title="Protection Profiles" columns={2}>
        {/* Protection Profiles */}
        <form.AppField
          name="protectionProfile"
          listeners={{
            onChange: () => {
              form.setFieldValue("technicalDecisions", []);
            },
          }}
        >
          {(field) => (
            <field.AutocompleteSelect
              label="Protection Profile"
              options={ppOptions}
            />
          )}
        </form.AppField>

        <form.AppField name="requirement">
          {(field) => <field.TextInput label="Requirement" fullWidth={false} />}
        </form.AppField>
      </form.FormSection>
    );
  },
});

export default EcrProtectionProfileSection;
